import ProjectList from "../../components/ProjectList/ProjectList";

const Portfolio = () => {
  return (
    <>
      <h2>Porfolio page</h2>
      <ProjectList/>
    </>
  );
};

export default Portfolio;
